import { IconProductCianLogo12, IconProductDocumentsVerified12, IconFinancePercent12 } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import {
  IconProductHighDemand16,
  IconComfortArmchair16,
  IconProductSuperAgent16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { TPhotoLabelColor } from 'shared/types/photoLabel';

export const COLOR_MAP: Partial<Record<TPhotoLabelColor, TColors>> = {
  blueGoodPrice: 'accent-main-primary',
  blueOnlyCian: 'accent-main-primary',
  blue: 'accent-main-primary',
  greenForCheckedOwner: 'control-positive-primary-default',
  greenForOwner: 'control-positive-primary-default',
  green: 'control-positive-primary-default',
  greenForSuperAgent: 'control-positive-primary-default',
  greenPremium: 'text-inverted-default',
  orange: 'accent-warning-primary',
  white: 'decorative-theme-dark',
  red: 'accent-negative-primary',
  purpleDiscountMortgage: 'decorative-accent-purple',
  orangeSubsidisedMortgage: 'decorative-theme-dark',
};

export const BACKGROUND_MAP: Record<TPhotoLabelColor, TColors> = {
  orange: 'surface-warning-default',
  blue: 'accent-main-secondary',
  blueOnlyCian: 'accent-main-secondary',
  blueGoodPrice: 'accent-main-secondary',
  green: 'surface-positive-default',
  greenForOwner: 'surface-positive-default',
  greenForCheckedOwner: 'surface-positive-default',
  greenPremium: 'accent-positive-primary',
  white: 'surface-neutral-default',
  grey: 'overlay-control-dark',
  red: 'surface-negative-default',
  purpleDiscountMortgage: 'decorative-accent-lavender',
  greenForSuperAgent: 'surface-positive-default',
  greenForSuperHost: 'surface-positive-default',
  orangeSubsidisedMortgage: 'brand-pink',
};

export const ICON_MAP: Partial<Record<TPhotoLabelColor, React.ReactElement>> = {
  blueOnlyCian: <IconProductCianLogo12 color="icon-main-default" />,
  greenForCheckedOwner: <IconProductDocumentsVerified12 color="icon-positive-default" />,
  purpleDiscountMortgage: <IconProductHighDemand16 />,
  greenForSuperAgent: <IconProductSuperAgent16 color="decorative-theme-green" />,
  greenForSuperHost: <IconProductSuperAgent16 color="decorative-theme-green" />,
  orangeSubsidisedMortgage: <IconFinancePercent12 />,
  orange: <IconComfortArmchair16 color="icon-warning-default" />,
};
